import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage';

const config = {
    apiKey: process.env.REACT_APP_API_KEY || 'AIzaSyCm4-NRey0XqwmRN3wWpLkz7S7n7fK_m2A',
    authDomain: process.env.REACT_APP_AUTH_DOMAIN || 'c-lab-fe10d.firebaseapp.com',
    databaseURL: process.env.REACT_APP_DATABASE_URL || 'https://c-lab-fe10d.firebaseio.com',
    projectId: process.env.REACT_APP_PROJECT_ID || 'c-lab-fe10d',
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET || 'c-lab-fe10d.appspot.com',
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID || '626214323079'
}

if (!firebase.apps.length) {
    firebase.initializeApp(config)
}

export const auth = firebase.auth()
export const db = firebase.database()
export const storage = firebase.storage()